import { render, staticRenderFns } from "./Supports.vue?vue&type=template&id=d6456022"
import script from "./Supports.vue?vue&type=script&lang=js"
export * from "./Supports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports